export default {
  Early: "Early",
  Late: "Late"
};



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/StatusTypes.js